export const TOGGLE_TEMPLATE_MODE = 'TOGGLE_TEMPLATE_MODE';

export const toggleTemplateMode = (value) => ({
	type: TOGGLE_TEMPLATE_MODE,
	value,
	meta: {
		allowedDuringApiCall: true,
	},
});
